const form = document.querySelector(".page-appointment form");

if (form) {
  const statusEl = form.querySelector("[data-appointment-status]");
  const fieldsWrap = form.querySelector(".page-appointment__fields");
  const submitButton = form.querySelector('button[type="submit"]');
  const dateField = form.elements["contact[appointment_date]"];
  const timeSelect = form.elements["contact[appointment_time]"];

  // Use custom validation; avoid native browser validation UI
  form.setAttribute("novalidate", "novalidate");

  // Set minimum date to today
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];
  if (dateField) {
    dateField.min = todayStr;
  }

  const getTimeSlots = (dateStr) => {
    if (!dateStr) return [];

    const date = new Date(dateStr);
    const dayOfWeek = date.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
    const slots = [];

    // Sat (6) - Wed (3): 10:00 - 22:00
    if ([6, 0, 1,4, 2, 3].includes(dayOfWeek)) {
      for (let h = 10; h < 22; h++) {
        slots.push(`${String(h).padStart(2, "0")}:00`);
        slots.push(`${String(h).padStart(2, "0")}:30`);
      }
    }
    // Thu (4): 22:00 - 23:00
    // else if (dayOfWeek === 4) {
    //   slots.push("22:00", "23:00");
    // }
    // Fri (5): 13:00 - 23:00
    else if (dayOfWeek === 5) {
      for (let h = 13; h < 23; h++) {
        slots.push(`${String(h).padStart(2, "0")}:00`);
        slots.push(`${String(h).padStart(2, "0")}:30`);
      }
    }

    return slots;
  };

  const populateTimeSlots = () => {
    if (!timeSelect || !dateField) return;

    const dateValue = dateField.value;
    const slots = getTimeSlots(dateValue);

    // Clear existing options (except placeholder)
    timeSelect.innerHTML = '<option value="" disabled selected>Select a time</option>';

    if (slots.length === 0) {
      timeSelect.disabled = true;
    } else {
      timeSelect.disabled = false;
      slots.forEach((slot) => {
        const option = document.createElement("option");
        option.value = slot;
        option.textContent = slot;
        timeSelect.appendChild(option);
      });
    }
  };

  if (dateField) {
    dateField.addEventListener("change", populateTimeSlots);
  }

  const normalizePhone = (raw) => (raw || "").replace(/[\s()-]/g, "");

  const isValidQatarPhone = (raw) => {
    const value = normalizePhone(raw);
    if (!value) return false;

    // Accept local 8 digits, or prefixed with +974/974 then 8 digits
    if (value.startsWith("+974")) {
      const nsn = value.slice(4);
      return /^\d{8}$/.test(nsn);
    }
    if (value.startsWith("974")) {
      const nsn = value.slice(3);
      return /^\d{8}$/.test(nsn);
    }
    return /^\d{8}$/.test(value);
  };

  const isValidBookingTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return false;

    const date = new Date(dateStr);
    const dayOfWeek = date.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
    const [hours, minutes] = timeStr.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;

    // Sat (6) - Wed (3): 10:00 - 22:00
    if ([6, 0, 1, 2, 3].includes(dayOfWeek)) {
      const minTime = 10 * 60; // 10:00 in minutes
      const maxTime = 22 * 60; // 22:00 in minutes
      return totalMinutes >= minTime && totalMinutes < maxTime;
    }

    // Thu (4): 22:00 - 23:00
    if (dayOfWeek === 4) {
      const minTime = 22 * 60; // 22:00 in minutes
      const maxTime = 23 * 60; // 23:00 in minutes
      return totalMinutes >= minTime && totalMinutes < maxTime;
    }

    // Fri (5): 13:00 - 23:00
    if (dayOfWeek === 5) {
      const minTime = 13 * 60; // 13:00 (1:00 PM) in minutes
      const maxTime = 23 * 60; // 23:00 in minutes
      return totalMinutes >= minTime && totalMinutes < maxTime;
    }

    return false;
  };

  const setStatus = (message, type) => {
    if (!statusEl) {
      return;
    }

    statusEl.textContent = message;
    statusEl.classList.remove("form-status--success", "form-status--error");

    if (type === "success") {
      statusEl.classList.add("form-status--success");
      statusEl.hidden = false;
    } else if (type === "error") {
      statusEl.classList.add("form-status--error");
      statusEl.hidden = false;
    } else if (type === "info") {
      statusEl.hidden = false;
    } else {
      statusEl.hidden = true;
    }
  };

  const getConfig = () => {
    if (!fieldsWrap) {
      return null;
    }

    const rawConfig = fieldsWrap.dataset.firebaseConfig || "";
    if (!rawConfig.trim()) {
      return null;
    }

    try {
      const parsed = JSON.parse(rawConfig);
      const requiredKeys = [
        "apiKey",
        "authDomain",
        "projectId",
        "appId",
      ];


      // Validate Qatar phone number before sending
      const phoneField = form.elements["contact[phone]"];
      const phoneValue = phoneField?.value || "";
      if (!isValidQatarPhone(phoneValue)) {
        setStatus(
          "Enter a valid Qatar phone number (8 digits; optionally with +974).",
          "error"
        );
        if (phoneField && typeof phoneField.focus === "function") {
          phoneField.focus();
        }
        return;
      }

      // Validate booking time
      const appointmentDateField = form.elements["contact[appointment_date]"];
      const appointmentTimeField = form.elements["contact[appointment_time]"];
      const dateValue = appointmentDateField?.value || "";
      const timeValue = appointmentTimeField?.value || "";

      if (!dateValue || !timeValue) {
        setStatus("Please select an appointment date and time.", "error");
        return;
      }

      // Verify time is within allowed slots for selected date
      const slots = getTimeSlots(dateValue);
      if (!slots.includes(timeValue)) {
        setStatus(
          "Please select a valid booking time: Sat–Wed 10 AM–10 PM, Thu 10 PM–11 PM, Fri 1 PM–11 PM.",
          "error"
        );
        if (appointmentTimeField && typeof appointmentTimeField.focus === "function") {
          appointmentTimeField.focus();
        }
        return;
      }

      const hasRequired = requiredKeys.every((key) => parsed[key]);
      return hasRequired ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  form.addEventListener("submit", async (event) => {
    // Always prevent default submission and stop propagation
    event.preventDefault();
    event.stopPropagation();

    const config = getConfig();
    if (!config) {
      setStatus(
        "Appointment setup issue. Please try again later.",
        "error"
      );
      return;
    }

    setStatus("Sending your appointment request...", "info");

    if (submitButton) {
      submitButton.disabled = true;
    }

    try {
      const { initializeApp } = await import(
        "https://www.gstatic.com/firebasejs/9.23.0/firebase-app.js"
      );
      const {
        getFirestore,
        addDoc,
        collection,
        serverTimestamp,
      } = await import(
        "https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore.js"
      );

      const app = initializeApp(config);
      const db = getFirestore(app);

      const payload = {
        name: form.elements["contact[name]"]?.value?.trim() || "",
        email: form.elements["contact[email]"]?.value?.trim() || "",
        phone: form.elements["contact[phone]"]?.value?.trim() || "",
        appointment_date:
          form.elements["contact[appointment_date]"]?.value?.trim() || "",
        appointment_time:
          form.elements["contact[appointment_time]"]?.value?.trim() || "",
        appointment_shop:
          form.elements["contact[appointment_shop]"]?.value?.trim() || "",
        page_url: window.location.href,
        created_at: serverTimestamp(),
      };

      const collectionName =
        fieldsWrap.dataset.firebaseCollection || "appointments";

      await addDoc(collection(db, collectionName), payload);

      setStatus("Thanks! Your appointment request has been received.", "success");
      form.reset();
    } catch (error) {
      setStatus(
        "Sorry, something went wrong. Please try again in a moment.",
        "error"
      );
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  });
}
